<template>
  <div class="order-card border-b-8 border-neutral-100 last:border-b-0">
    <div
      class="px-4 py-4 flex justify-between items-center gap-6 shadow-border-b mdmax:px-4 mdmax:py-4"
    >
      <div
        class="flex gap-3 mdmax:items-start mdmax:gap-1 mdmax:flex-col justify-between items-center"
      >
        <span>
          <span
            class="inline-flex px-2 py-1 text-xs rounded-md mdmax:flex-shrink-0 text-center"
            :class="statusClass"
            >{{ data.status }}</span
          >
        </span>
        <div>
          <span
            class="text-neutral-700 font-medium mdmax:text-sm block text-xs mb-1"
            >{{ data.created_at | formatDate }}</span
          >
          <span class="text-neutral-500 mdmax:text-sm block text-xs mb-1">
            <span class="text-neutral-700 font-medium">Nomor pesanan:</span>
            {{ data.order_id }}
          </span>
          <p
            class="text-neutral-500 text-xs flex items-center gap-2 mdmax:flex-col mdmax:gap-1 mdmax:items-start"
          >
            <span>
              <span class="text-neutral-700 font-medium">Borzo Tracking:</span>
              <a :href="data.borzo_tracking_url" target="_blank" class="text-blue-500 underline">{{ data.borzo_order_id }}</a>
            </span>
          </p>
        </div>
      </div>

      <span
        v-if="isMobile"
        class="inline-block cursor-pointer"
        @click="expand()"
      >
        <Chevron direction="down" />
      </span>
    </div>

    <div
      class="flex justify-between flex-wrap items-start shadow-border-b text-neutral-500 mdmax:flex-col mdmax:shadow-none"
      :class="{ hidden: !visibleContent && isMobile }"
    >
      <div
        class="w-2/5 border-r p-4 mdmax:w-full mdmax:p-4 mdmax:border-none mdmax:shadow-border-b"
      >
        <div class="flex justify-between items-start gap-6 mdmax:gap-2">
          <div class="w-2/5 mdmax:w-1/2">
            <p class="text-sm font-medium mb-1 text-neutral-700">
              Nama Pengirim
            </p>
            <p
              class="font-medium mb-1 leading-5 max-h-10 h-10 overflow-y-hidden"
              :title="data.sender_name"
            >
              {{ data.sender_name }}
            </p>
            <p class="text-neutral-400 text-sm">{{ data.sender_phone }}</p>
          </div>
          <div class="w-3/5 mdmax:w-1/2">
            <p class="text-sm font-medium mb-1 text-neutral-700">
              Alamat Pengirim
            </p>
            <p
              class="ellipsis overflow-hidden mdmax:h-auto mdmax:overflow-auto"
            >
              {{ data.sender_address }}
            </p>
          </div>
        </div>
        <div class="mt-4 p-2 bg-neutral-200 rounded-md">
          <p class="text-sm font-medium mb-1 text-neutral-700">Detail Alamat</p>
          <p>{{ data.sender_detail_address || "-" }}</p>
        </div>
      </div>
      <div
        class="w-2/5 border-r p-4 mdmax:border-none mdmax:p-4 mdmax:w-full mdmax:shadow-border-b"
      >
        <div class="flex justify-between items-start gap-6 mdmax:gap-2">
          <div class="w-2/5 mdmax:w-1/2">
            <p
              class="text-sm font-medium mb-1 text-neutral-700 whitespace-nowrap"
            >
              Nama Penerima
            </p>
            <p
              class="font-medium mb-1 leading-5 max-h-10 h-10 overflow-y-hidden"
              :title="data.receiver_name"
            >
              {{ data.receiver_name }}
            </p>
            <p class="text-neutral-400 text-sm">{{ data.receiver_phone }}</p>
          </div>
          <div class="w-3/5 mdmax:w-1/2">
            <p class="text-sm font-medium mb-1 text-neutral-700">
              Alamat Penerima
            </p>
            <p
              class="ellipsis overflow-hidden mdmax:h-auto mdmax:overflow-auto"
            >
              {{ data.receiver_address }}
            </p>
          </div>
        </div>
        <div class="mt-4 p-2 bg-neutral-200 rounded-md">
          <p class="text-sm font-medium mb-1 text-neutral-700">
            Detail Alamat
          </p>
          <p>{{ data.receiver_detail_address || "-" }}</p>
        </div>
      </div>
      <div class="w-1/5 p-4 mdmax:w-full mdmax:shadow-border-b">
        <div class="mb-6">
          <p class="text-sm font-medium mb-1 text-neutral-700">Barang</p>
          <p>{{ data.item_description }}</p>
        </div>
        <div class="">
          <p class="text-sm font-medium mb-1 text-neutral-700">Nilai Barang</p>
          <p>{{ (data.item_value || 0) | currencyFormat }}</p>
        </div>
      </div>
      <div class="w-full p-4 border-t mdmax:border-none mdmax:shadow-border-b">
        <p class="text-sm font-medium mb-2 text-neutral-700">Rincian Pembayaran</p>
        <div class="flex flex-wrap gap-x-8 gap-y-2 text-sm">
          <div>
            <p class="text-neutral-500 mb-1">Biaya Asuransi</p>
            <p class="font-medium text-neutral-700">{{ (data.insurance_fee_amount || 0) | currencyFormat }}</p>
          </div>
          <div>
            <p class="text-neutral-700 font-bold mb-1">Total Pembayaran</p>
            <p class="font-bold text-neutral-700">{{ (data.payment_amount || 0) | currencyFormat }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex"
import { currencyFormat } from "@/util"
import dayjs from "dayjs"

export default {
  filters: {
    currencyFormat,
    formatDate(date) {
      if (!date) return "-"
      return dayjs(date).format("DD MMM YYYY, HH:mm")
    }
  },
  components: {
    Chevron: () =>
      import(/* webpackChunkName: "Icons" */ "@/components/Icons/Chevron")
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      visibleContent: false
    }
  },
  methods: {
    expand() {
      this.visibleContent = !this.visibleContent
    }
  },
  computed: {
    ...mapGetters("common", ["isMobile"]),
    statusClass() {
      switch(this.data.status) {
        case 'Menunggu Pembayaran':
          return 'text-white bg-system-warning'
        case 'Selesai':
          return 'text-white bg-system-success'
        case 'Dalam Pengiriman':
          return 'text-white bg-blue-500'
        default:
          return 'text-neutral-500 bg-neutral-300'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.ellipsis {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.25;
  height: 60px;
  word-break: break-all;
}
</style>
